module.exports = __webpack_public_path__ + "img/start_point.5e247f79.svg";